import { isPastDateWithTZ } from 'srcReact/helpers/datetimeHelper'
import { getIdExternalApiAuth } from 'srcReact/helpers/userHelper'

export function getCreateMixrParams(mixr, selectedInterests) {
  const {
    name,
    description,
    attendance_limits,
    attending_type,
    interests,
    group,
    picture,
    location: mixrLocation,
    local_start_at,
    local_end_at,
    join_in_link,
    additional_information,
    fees,
    is_preview,
    is_invite_scheduled,
    local_invite_send_date,
    virtual_meeting_provider,
    id_external_api_auth,
    recurrence: {
      type: recurrenceType,
      events,
      weeks_count,
      months_count,
      days_of_week,
      day_of_week,
      week_of_month,
      occurence_in_month,
      end_date
    },
    draft_id
  } = mixr
  let updatedAttendanceLimit = []
  if (attendance_limits && attendance_limits.length > 0) {
    updatedAttendanceLimit = attendance_limits.filter((x) => {
      if (x.limit !== -1 && x.limit != '') {
        if (
          (attending_type === 'in_person' && x.type === 'in_person') ||
          (attending_type === 'virtual' && x.type === 'virtual') ||
          attending_type === 'both'
        ) {
          return x
        }
      }
    })
  }

  const selectedGroupId = group && (group.group_id || group.id)

  let isStartDateInPast = false
  if (attending_type !== 'none' && mixrLocation && mixrLocation.timezone) {
    isStartDateInPast = isPastDateWithTZ(local_start_at, mixrLocation.timezone)
  }
  const correctedFeesFormat =
    fees &&
    fees.map(
      ({ currency_symbol, attending_type, category, currency_id, currency_name, is_other_category, ...fee }) => fee
    )
  const mixrInfomation = {
    draft_id: draft_id,
    name: name,
    ...(picture && picture.id > 0
      ? {
          picture_id: picture.id,
          picture_name: picture.filename || picture.name || '',
          picture_mime_type: picture.mimeType || picture.mime_type || ''
        }
      : {}),
    description: description,
    //if mixr is coming from draft where interest step is not completed then use group interests
    interest_ids:
      interests?.length > 0
        ? interests.map((i) => i.id).join(',')
        : selectedInterests?.length > 0
        ? selectedInterests.map((i) => i.id).join(',')
        : '',
    ...(attending_type !== 'virtual' && {
      location: JSON.stringify(mixrLocation)
    }),
    start_at: recurrenceType === 'none' || !isStartDateInPast ? local_start_at : events[1].start_at,
    end_at: recurrenceType === 'none' || !isStartDateInPast ? local_end_at : events[1].end_at,
    attending_type: attending_type,
    ...((attending_type === 'virtual' || attending_type === 'both') && {
      virtual_meeting_provider: virtual_meeting_provider
    }),
    id_external_api_auth: id_external_api_auth || getIdExternalApiAuth() || 0,
    group_id: selectedGroupId,
    ...(updatedAttendanceLimit.length > 0 && { attendance_limits: JSON.stringify(updatedAttendanceLimit) }),
    recurrence_type: recurrenceType,
    ...((attending_type === 'virtual' || attending_type === 'both') && {
      join_in_link: join_in_link
    }),
    ...(attending_type === 'virtual' && {
      timezone_id: mixrLocation?.timezone?.timezone_id || mixrLocation?.timezone?.id
    }),
    additional_information: additional_information ? additional_information : '',
    ...(recurrenceType !== 'none' && { recurrence_end_date: end_date }),
    ...(recurrenceType === 'weekly' && { recurrence_weeks_count: weeks_count || 1 }),
    ...(recurrenceType === 'weekly' && { recurrence_days_of_week: days_of_week }),
    ...(recurrenceType === 'monthly' && { recurrence_months_count: months_count || 1 }),
    ...(recurrenceType === 'monthly' && { recurrence_day_of_week: day_of_week }),
    ...(recurrenceType === 'monthly' && { recurrence_occurence_in_month: week_of_month || occurence_in_month }),
    ...(fees && fees.length > 0 && { fees: JSON.stringify(correctedFeesFormat) }),
    is_invite_scheduled: is_invite_scheduled,
    ...(is_invite_scheduled === 1 && { invite_send_date: local_invite_send_date })
  }
  return mixrInfomation
}
